import { memo, useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { PlayerPauseIcon, PlayerPlayIcon } from 'foundations-assets';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import I18n from 'I18n';
import { MediaElementContext } from '../../context/MediaElementContext';
import { useControlsStatus } from '../../hooks/_internal/useShouldDisableControls';
import { jsx as _jsx } from "react/jsx-runtime";
const PlayPauseBtn = /*#__PURE__*/memo(props => {
  var _props$tooltipMessage;
  const {
    play,
    pause
  } = useContext(MediaPlaybackControlsContext);
  const {
    recordingUrl
  } = useContext(MediaElementContext);
  const {
    onPlayCallback,
    onPauseCallback,
    size = 'md',
    shape = 'circle',
    use = 'tertiary'
  } = props;
  const handlePlayClick = () => {
    play();
    if (onPlayCallback) {
      onPlayCallback();
    }
  };
  const handlePauseClick = () => {
    pause();
    if (onPauseCallback) {
      onPauseCallback();
    }
  };
  const {
    isDisabled,
    isError,
    isLoaded,
    isPaused,
    status
  } = useControlsStatus();
  let tooltipMessage = (_props$tooltipMessage = props.tooltipMessage) !== null && _props$tooltipMessage !== void 0 ? _props$tooltipMessage : null;
  if (!tooltipMessage) {
    tooltipMessage = !isLoaded && !isError ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.media.mediaPlayer.loadingTooltip"
    }) : null;
  }
  return /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": "mediaPlayerControls-playButton",
    "data-media-status": status,
    onClick: isPaused ? handlePlayClick : handlePauseClick,
    disabled: isDisabled,
    tooltip: recordingUrl ? tooltipMessage : null,
    use: use,
    size: size,
    shape: shape,
    "aria-label": isPaused ? I18n.text('recordingReviewComponents.media.mediaPlayer.ariaLabels.play') : I18n.text('recordingReviewComponents.media.mediaPlayer.ariaLabels.pause'),
    children: isPaused ? /*#__PURE__*/_jsx(PlayerPlayIcon, {
      "data-test-id": "playerIconPlay"
    }) : /*#__PURE__*/_jsx(PlayerPauseIcon, {
      "data-test-id": "playerIconPause"
    })
  });
});
export default PlayPauseBtn;